module.exports = __webpack_public_path__ + "img/nodata.78e01aa8.png";